import {
  FieldSwitch,
  FlexBox,
  Icon,
  Text,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { ComponentProps } from 'react';

/** Represents an instagram feature input. */
type InstagramFeatureToggleProps = {
  /** The input. */
  readonly input: ComponentProps<typeof FieldSwitch>['input'];
  /** The input label. */
  readonly inputLabel: string;
  /** The tooltip label */
  readonly tooltipLabel: string;
};

/** Represents a toggle switch for enabling/disabling an instagram feature. */
export const InstagramFeatureToggle = ({
  input,
  inputLabel,
  tooltipLabel,
}: InstagramFeatureToggleProps): JSX.Element => {
  return (
    <FlexBox gap="200" alignItems="center">
      <FieldSwitch input={input} />

      <Text.Paragraph>{inputLabel}</Text.Paragraph>

      <Tooltip
        content={tooltipLabel}
        wrap="div"
        wrapProps={{ style: { display: 'flex' } }}
        dark
      >
        <Icon name="info" />
      </Tooltip>
    </FlexBox>
  );
};
